import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/home-photo.png";
import Tilt from "react-parallax-tilt";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Home2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/registration"); // This will navigate to the "/another-page" route
  };


  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              EMPOWERING. <span className="purple"> INNOVATING. </span> EDUCATING
            </h1>
            <p className="home-about-body">
              At Choicest Fruit<span className="small-r-symbol">®</span>, we believe technology is not just
               about innovation, it’s about elevating people, strengthening communities, protecting our
                environment, and shaping a future where everyone can thrive. Our work is rooted in  <b className="purple">localized 
                innovation</b>, where young people design and build solutions for the very communities they live 
                in, addressing real challenges they see every day. But innovation alone isn’t enough. 
                We double down on <b className="purple">storytelling</b>, helping participants articulate not just 
                what they create, but why it matters. This narrative power transforms projects into movements
                 and ideas into opportunities, resonating far beyond the classroom.             
              <br />
              <br />
              As a forward-thinking social enterprise, we are reimagining how technology is developed, taught, 
              shared, and used, ensuring it serves the needs of people and reflects humanity’s deepest values.
               Whether through peer mentoring across continents, internships with local companies, or shared
                showcases of youth innovation, we create spaces where people connect, inspire, and grow together.
                 We are committed to transforming lives and communities by delivering training, mentorship,
                  and hands-on opportunities in STEM, software development, electronics, robotics, ethical
                   technology practices and organic urban gardening.
              <br />
              <br />
              Our approach is holistic and inclusive, blending <b className="purple">innovation with purpose</b>, technical skills with
               <b className="purple"> ethical reflection</b>, and <b className="purple">cultural awareness with social impact</b>. We equip children, youth, underserved
                communities, educators, seniors, and tech companies with the tools to thrive in today’s digital 
                world while shaping the technologies of tomorrow. By prioritizing accessibility, we ensure our
                 programs reach those often left behind, empowering individuals from all backgrounds to become
                  creators, leaders, and changemakers in the digital age.
               <br />
              <br />
              <i>
               Through <b className="purple">empowerment</b>, we help participants move beyond using technology to creating it, developing solutions that respond to real community needs and global challenges. 
                We foster <b className="purple">innovation</b>, <b className="purple">leadership</b>, <b className="purple">entrepreneurship</b>, and <b className="purple">social contribution</b> through
                  experiential learning, mentorship, and collaboration with industry partners.
              </i>
              <br />
              <br />
              <i>
                With <b className="purple">collaborative consultation</b>, we bring tech developers, educators and users together in spaces of
                 shared learning and discourse, ensuring technologies are co-created with the very communities
                  they serve.
               </i>
              <br />
              <br />
              <i>
                Our <b className="purple">products and solutions</b>, from educational apps and games to subscription-based learning
                 resources and ethical design tools, embody human values, strengthen communities, and inspire
                  meaningful action. By combining practical skills, industry partnerships, and value-driven
                   design, Choicest Fruit is building not only future-ready innovators but also a more just, 
                   inclusive, and sustainable digital society.

              </i>
      
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>JOIN OUR PROGRAMS</h1>
            <p>
              Fostering <span className="purple">innovation</span>, <span className="purple">leadership</span>, <span className="purple">entrepreneurship</span>, and <span className="purple"> social contribution </span>
            </p>
            <Button onClick={handleClick}>Get Started</Button>
    
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
